import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03942833"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed-button" }
const _hoisted_2 = { class: "d-flex justify-content-start align-items-center" }
const _hoisted_3 = { class: "text-size-10 line-height-14" }

import { computed, PropType } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import WatchLaterButton from "@/components/atoms/button/WatchLaterButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderFixedButton',
  props: {
  hasSub: {
    type: Boolean,
    default: false
  },
  isDisabled: {
    type: Boolean,
    default: false
  },
  isShownWatchLaterButton: {
    type: Boolean,
    default: false
  },
  isRegisteredWatchLater: {
    type: Boolean,
    default: false
  },
  enabledVariant: {
    type: String,
    default: "secondary"
  },
  abTestGroup3300: {
    type: String as PropType<"B" | "C" | null>,
    default: null
  }
},
  emits: ["change-watch-later", "click"],
  setup(__props, { emit: emits }) {

const props = __props;



const className = computed(() => {
  return props.hasSub ? "py-1" : null;
});
const variant = computed(() => {
  return props.isDisabled ? "gray-03" : props.enabledVariant;
});
const watchLaterButtonWrapperClass = computed(() => {
  return props.isShownWatchLaterButton ? "flex-grow-1" : null;
});
const applyButtonWrapperClass = computed(() => {
  return props.isShownWatchLaterButton ? "flex-grow-11" : "flex-grow-1";
});
const buttonClass = computed(() => {
  if (props.isDisabled || props.abTestGroup3300 === null) {
    return null;
  }

  return `ab-test-group-3300-${props.abTestGroup3300.toLowerCase()}`;
});



function onChangeWatchLater() {
  emits("change-watch-later");
}
function onClick() {
  emits("click");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.isShownWatchLaterButton)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(watchLaterButtonWrapperClass.value)
          }, [
            _createVNode(WatchLaterButton, {
              isRegisteredWatchLater: __props.isRegisteredWatchLater,
              onClick: onChangeWatchLater
            }, null, 8, ["isRegisteredWatchLater"])
          ], 2))
        : _createCommentVNode("", true),
      _createTextVNode(),
      _createElementVNode("div", {
        class: _normalizeClass(applyButtonWrapperClass.value)
      }, [
        _createVNode(AppButton, {
          block: "",
          class: _normalizeClass([className.value, buttonClass.value]),
          variant: variant.value,
          disabled: __props.isDisabled,
          onClick: onClick
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default"),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "sub")
            ])
          ], undefined, true),
          _: 3
        }, 8, ["class", "variant", "disabled"])
      ], 2)
    ])
  ]))
}
}

})